// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
// eslint-disable-next-line import/no-extraneous-dependencies
import 'core-js/stable';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'regenerator-runtime/runtime';
import 'bootstrap';
import '../i18n';

import React from 'react';
import { createRoot } from 'react-dom/client';

import configureStore from '../store/configureStore';

import AppRoutes from '../AppRoutes';
import { loadConfig } from '../config';

export const { store } = configureStore();

document.addEventListener('DOMContentLoaded', async () => {
  await loadConfig();
  const container = document.getElementById('react_content');
  const root = createRoot(container);
  root.render(<AppRoutes store={store} />);
});
